import { keyframes } from 'tss-react'
import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  headerArea: {
    position: 'relative',
    paddingBottom: theme.spacing(4),
  },
  backgroundFeatures: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
  },
  headerAreaContent: {
    maxWidth: 904,
    margin: '0 auto',
    textAlign: 'center',
    position: 'relative',
    zIndex: '2',
  },
  headerPreTitle: {
    verticalAlign: 'middle',
    '& > *': {
      verticalAlign: 'middle',
    },
  },
  headerAvatar: {
    display: 'inline-block',
  },
  logoWrapper: {
    display: 'inline-block',
    marginBottom: theme.spacing(2),
  },
  logo: {
    maxHeight: 96,
    maxWidth: 320,
  },
  avatar: {
    width: 'auto !important',
    minWidth: '40px !important',
    '& img': {
      minHeight: '48px !important',
      minWidth: '48px !important',
      width: 'auto !important',
      margin: `${theme.spacing(1)} !important`,
    },
  },
  headerTitle: {
    verticalAlign: 'top',
  },
  headerCta: {
    margin: '0 auto',
    maxWidth: 240,
    background: 'rgba(0, 0, 0, 0.12)',
    borderRadius: '8px',
  },
  applySent: {
    paddingTop: 1,
    verticalAlign: 'middle',
    '& *': {
      verticalAlign: 'middle',
    },
    '& svg': {
      transform: 'translateY(-2px)',
    },
  },
  headerAreaShadeOverlay: {
    display: 'none',
    position: 'absolute',
    height: '100%',
    width: '100%',
    top: '0',
    left: '0',
    zIndex: '1',
    pointerEvents: 'none',
    animation: `${keyframes`
      from: { opacity: 0 }
      to: { opacity: 1 }
    `} 1s ease 0.5s backwards`,
    background: 'radial-gradient(ellipse at bottom center, rgba(0, 51, 204, 0.2) 0%, rgba(0, 51, 204, 0) 60%)',
  },
  headerAreaCircleOverlay: {
    display: 'none',
    position: 'absolute',
    height: 700,
    width: 700,
    bottom: 132,
    left: '50%',
    transform: 'translate(-50%, 50%)',
    zIndex: '0',
    opacity: '0.1',
    pointerEvents: 'none',
    border: '2px solid rgba(0, 51, 204, 1)',
    borderRadius: '100%',
    animation: `${keyframes`
      from: { opacity: 0 }
      to: { opacity: 0.1 }
    `} 1s ease 0.5s backwards`,
  },
}))
